import { useState, FormEvent, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import Form from "../../../../../components/common/form/Form";
import { fetchPdf, showToast } from "../../../../../helpers/utils/Utils";
import Modal from "../../../../../components/common/form/Modal";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import {
    useCheckHoaOrderResultValidMutation,
    useGenerateHoaPdfServiceMutation,
    useGenerateTgxPdfServiceMutation,
    useIsPdfExistMutation, useLazyCheckTaxOrderResultValidQuery
} from "../../../ordersApi";
import { tgxApi } from "../../../../../app/tgxApi";
import { useLazyCheckNationalTaxOrderResultValidQuery } from "../../../nationalOrdersApi";


interface GenerateActivePdfProps {
    show: boolean;
    setShow: (show: boolean) => void;
    orderId: any;
    customerId: string;
    tenant: string;
    type: string;
    productType: string;
    setIsValidDataForPdfGenerate: any;
    orderResult: any;
    isHoa?: any;
    productSchema?: any;
    setIsPdfExist?: any
}

export default function GenerateActivePdf({
    show,
    setShow,
    orderId,
    customerId,
    tenant,
    type,
    productType,
    setIsValidDataForPdfGenerate,
    orderResult,
    isHoa,
    productSchema, setIsPdfExist
}: GenerateActivePdfProps) {

    const dispatch = useDispatch();
    const [cancelTask, setCancelTask] = useState<boolean>(true);
    const [disable, setDisable] = useState<boolean>(false);

    // const isLoading;
    const [generateTaxPDf, generateTaxPDfApi] = useGenerateTgxPdfServiceMutation();
    const [generateHoaPDf, generateHoaPDfApi] = useGenerateHoaPdfServiceMutation();
    const [checkNationalTaxOrderResultValid] = useLazyCheckNationalTaxOrderResultValidQuery();
    const [checkTaxOrderResultValid] = useLazyCheckTaxOrderResultValidQuery();
    const [checkHoaOrderResultValid] = useCheckHoaOrderResultValidMutation();
    const [checkPdfExist, {data: pdfExistData}] = useIsPdfExistMutation();


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setDisable(true);

        if (type === "taxCert") {

            try {
                const result = await generateTaxPDf({
                    orderId: orderId,
                    customerId: customerId,
                    tenant: tenant,
                    checkValidation: false,
                    cancelExistingTask: cancelTask
                }).unwrap();

                if (result['errorCode'] === 200) {
                    showToast("PDF created successfully!");
                    setShow(false);
                    checkPdfExist({
                        'orderId': orderId,
                        'orderFileType': ["TaxCertificate", "CADPrintout"],
                        'type': 'New'
                    }).then(data => {
                        setIsPdfExist(data.data);
                    }).catch(error => {
                        console.log("Error fetching pdf existence:", error);
                    });

                    dispatch(tgxApi.util.invalidateTags(["getOrderResultByOrderId"]))

                    if (productSchema == "Default") {
                        try {
                            const { data } = await checkTaxOrderResultValid(orderResult);
                            setIsValidDataForPdfGenerate(data === true);
                        } catch (error) {
                            console.error("Error while validating order result:", error);
                        }
                    } else {
                        const { data } = await checkNationalTaxOrderResultValid(orderResult.data);
                        setIsValidDataForPdfGenerate(data === true);
                    }

                    if (result?.id) {
                        const fileUrl = `/ajax/view-file/${result.id}`;
                        const blobUrl = await fetchPdf(fileUrl); // your utility to convert file to blob URL
                        window.open(blobUrl, '_blank');
                    }
                } else {
                    if (result['message'] === "Can not generate PDF while task is incomplete!") {
                    } else {
                        showToast(result["message"], "error");
                    }
                    setDisable(false);
                }
            } catch (error: any) {
                if (error?.data?.message === "Can not generate PDF while task is incomplete!") {
                } else {
                    showToast(error?.data?.message || "Something went wrong");
                }
            }
        } else {
            try {
                const result = await generateHoaPDf({
                    orderId: orderId,
                    customerId: customerId,
                    tenant: tenant,
                    checkValidation: false,
                    cancelExistingTask: cancelTask,
                }).unwrap();

                if (result['errorCode'] === 200) {
                    showToast("PDF created successfully!");
                    setShow(false);
                    checkPdfExist({
                        'orderId': orderId,
                        'orderFileType': [productType === "HOA_FULL" ? "HOAFull" : "HOAContact", "CADPrintout"],
                        'type': 'New'
                    });
                    dispatch(tgxApi.util.invalidateTags(["getOrderResultByOrderId"]))
                    try {
                        const result = await checkHoaOrderResultValid({ orderResult, orderId }).unwrap();
                        setIsValidDataForPdfGenerate(result); // same as old flow
                    } catch (error) {
                        console.error('Error validating HOA Order Result:', error);
                    }
                    if (result?.id) {
                        const fileUrl = `/ajax/view-file/${result.id}`;
                        const blobUrl = await fetchPdf(fileUrl); // your utility to convert file to blob URL
                        window.open(blobUrl, '_blank');
                    }
                } else {
                    if (result['message'] === "Can not generate PDF while task is incomplete!") {
                    } else {
                        showToast(result["message"], "error");
                    }
                    setDisable(false);
                }
            } catch (error: any) {
                if (error?.data?.message === "Can not generate PDF while task is incomplete!") {
                } else {
                    showToast(error?.data?.message || "Something went wrong");
                }
            }

        }
    }

    return (
        <Modal
            title={"Warning"}
            show={show}
            setShow={setShow}
            className={"w-3/6"}
            hoa={isHoa}
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={(
                        <>
                            <div className="modal-body border-b border-text-1 p-2">
                                <p>There are pending tasks for this order. All tasks must be completed or canceled prior
                                    to PDF generation.</p>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-group input-group-sm">
                                            <input
                                                type="checkbox"
                                                id="ProcessingConsultantYN"
                                                value={cancelTask.toString()}
                                                checked={cancelTask}
                                                onChange={() => setCancelTask(!cancelTask)}
                                                className="check-box"
                                            />
                                            <b>
                                                <label
                                                    className="checkbox-inline ml-3 mt-1"
                                                    htmlFor="ProcessingConsultantYN"
                                                >
                                                    Cancel active tasks
                                                </label>
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "cancel",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Generate PDF",
                                            type: "submit",
                                            isLoading: generateTaxPDfApi.isLoading,
                                        },
                                        buttonType: "button",

                                    }
                                ]}
                                align={"end"}
                                gap={2}

                            />
                        </>
                    )} />
                </>
            }

        />
    );
}